import { render, staticRenderFns } from "./UserRedIcon.vue?vue&type=template&id=703a3274"
import script from "./UserRedIcon.vue?vue&type=script&lang=js"
export * from "./UserRedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports